import {openProductPopupHandler} from "./productPopup";

const callBack = document.querySelector('.js-popup-callback');

if(callBack) {
    callBack.addEventListener('click', () => {
        openProductPopupHandler('product-callback');
    });
}
